import type { HTMLAttributes, ReactNode } from "react";
import Box from "@mui/material/Box";

type CustomTabPanelProps = {
    children?: ReactNode;
    index: number;
    value: number;
} & HTMLAttributes<HTMLDivElement>;

const CustomTabPanel = (props: CustomTabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
};

export default CustomTabPanel;
